import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contentTypeText", "contentTypePdf", "textContentSection", "pdfContentSection", "pdfInput", "pdfPreview", "pdfPreviewName", "pdfPreviewSize"]

  connect() {
    this.updateVisibility()
  }

  toggleContentType(event) {
    this.updateVisibility()
  }

  updateVisibility() {
    const isTextMode = this.contentTypeTextTarget.checked

    if (isTextMode) {
      this.textContentSectionTarget.classList.remove("hidden")
      this.pdfContentSectionTarget.classList.add("hidden")
    } else {
      this.textContentSectionTarget.classList.add("hidden")
      this.pdfContentSectionTarget.classList.remove("hidden")
    }
  }

  previewPdf(event) {
    const file = event.target.files[0]

    if (file && file.type === "application/pdf") {
      this.pdfPreviewTarget.classList.remove("hidden")
      this.pdfPreviewNameTarget.textContent = file.name
      this.pdfPreviewSizeTarget.textContent = `(${this.formatFileSize(file.size)})`
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
  }
}
